<template>
  <div>
    <table class="table table-sm">
      <thead>

        <tr>
          <th>Clé</th>
          <th>Titre</th>
          <th>Fournisseur</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='ticket in tickets' class="row-hover" :key="ticket.ticket_id">
          <router-link class="nav-link" tag="td" v-text="ticket.ticket_id" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
          <router-link class="nav-link" tag="td" v-text="ticket.title" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
          <router-link class="nav-link" tag="td" v-text="ticket.serviceprovider" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'MyTickets',
  props: {
    tickets: {},
  },

}
</script>
